import { Settings2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getCapabilityColors } from '@/lib/capability-colors';
import { useCapabilityDetail } from '@/lib/capability-detail-context';

interface CapabilityPlaceholderProps {
   typeLabel: string;
   capabilityName: string;
   description?: string;
}

export function CapabilityPlaceholder({ typeLabel, capabilityName, description }: CapabilityPlaceholderProps) {
   const ctx = useCapabilityDetail();
   const colors = getCapabilityColors(typeLabel.toLowerCase().replace(/\s+/g, '_'));
   const Icon = colors.icon;

   return (
      <div className="flex flex-col items-center justify-center py-20 px-6">
         <div className={`flex h-16 w-16 items-center justify-center rounded-2xl ${colors.bgLight} mb-4`}>
            <Icon size={32} className={colors.text} />
         </div>
         <h2 className="text-lg font-semibold text-slate-900 mb-1">{capabilityName}</h2>
         <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium mb-4 ${colors.bgLight} ${colors.text}`}
         >
            {typeLabel}
         </span>
         {description && (
            <p className="text-sm text-slate-600 text-center max-w-md mb-6">{description}</p>
         )}
         <Button
            variant="outline"
            size="sm"
            onClick={() => ctx?.setIsSettingsOpen(true)}
            className="inline-flex items-center gap-1.5 mb-6"
         >
            <Settings2 size={14} />
            Open Settings
         </Button>
         <p className="text-xs text-slate-400 text-center max-w-sm">
            A dedicated editor for {typeLabel} capabilities is coming soon.
         </p>
      </div>
   );
}
